import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { AIDisclosureResultState } from '../types';
import type { Disposable } from '@patsnap/tahiti-core';

export const AIDisclosureResultModel = Symbol('AIDisclosureResultModel');

export interface AIDisclosureResultModel extends AbstractModel<AIDisclosureResultState>, Disposable { }
